import * as React from 'react';

export function LoadingScreen() {
  return(<div className="flex flex-col items-center justify-center loader-container mt-24">
    <div className="loader mt-4"></div>
  </div>);
}
